import { TradeRestriction } from "./tradeRestriction";

export class TradePortfolio {
  public id;
  public name;
  public tradingRestrictions: Array<TradeRestriction>;

  public constructor(tradePortfolio: any) {
    this.id = tradePortfolio.id;
    this.name = tradePortfolio.name;
    this.tradingRestrictions = tradePortfolio.tradingRestrictions.map(tr => new TradeRestriction(tr));
  }
}



// WEBPACK FOOTER //
// ./src/app/trading/models/tradePortfolio.ts